import tw from "tailwind-styled-components";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
} from "../../Components/Styles/PageStyles";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { useEffect, useState } from "react";
import CommissionSummaryCards from "../../Components/Revenue/CommissionSummaryCards";
import Table from "../../Components/Revenue/Table";
import SideModal from "../../Components/SideModal";
import TrackCommission from "../../Components/Revenue/TrackCommission";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import ViewCommissionModal from "../../Components/Revenue/ViewCommissionPaidModal";
import ViewCollectionModal from "../../Components/Revenue/ViewCollectionModal";

const Revenue = () => {

  const user = useSelector((state) => state.UserReducer.user)
  const [selectedData, setSelectedData] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isTrackCommissionModalOpen, setIsTrackCommissionModalOpen] = useState(false);
  const [filterType, setFilterType] = useState();
  const [searchQuery, setSearchQuery] = useState();
  const [isViewCommissionModalOpen, setIsViewCommissionModalOpen] = useState(false);
  const [commissionData, setCommissionData] = useState([]);
  const [activeLeaseData, setActiveLeaseData] = useState([]);
  const [collectionDetail, setCollectionDetail] = useState(false);
  const [collectionList, setCollectionList] = useState([]);

  //-----Fetch Commission------------
  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/deal/commission/list?${query}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  }

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.data);
      setActiveLeaseData(res.activeLease);
      setSummaryData(res.stats);
      setIsFocused(true);
    }
  };
  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured")
  }

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  })

  useEffect(() => {
    getListMutate({ searchQuery, filterType })
  }, [])

  //---------Edit Track Commission---------
  const editTrackCommission = async (values) => {
    return await axios.post(`${Config.apiUrl}/deal/commission/markpaid`,
      values, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/json",
      },
    }
    );
  };

  const onTrackCommissionSuccess = (data) => {
    setIsTrackCommissionModalOpen(false);
    setIsViewCommissionModalOpen(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  }

  const onTrackCommissionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured")
  }

  const { isLoading: trackCommissionLoading,
    mutate: trackCommissionMutate } = useMutation(
      editTrackCommission, {
      onSuccess: onTrackCommissionSuccess,
      onError: onTrackCommissionError,
    }
    )


  //---------- Get Commission Paid By -------------
  const getCommissionPaid = async (dealId) => {
    const response = await axios.get(
      `${Config.apiUrl}/deal/commission/payment/list?dealId=${dealId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const getCommissionSuccess = (res) => {
    if (res?.isSuccess) {
      const list = res.data || [];

      const totalReceived = list.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );

      if (totalReceived > 0) {
        setCommissionData(list);
        setIsViewCommissionModalOpen(true);
      } else {
        setCommissionData([]);
        setIsViewCommissionModalOpen(true);
        //toast.info("No commission received yet");
      }

    }
  };

  const getCommissionError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching commission");
  };

  const { mutate: getCommissionPaidMutate, isLoading: commissionPaidLoading } =
    useMutation(getCommissionPaid, {
      onSuccess: getCommissionSuccess,
      onError: getCommissionError,
    });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (isFilterApplied) {
      setIsFilterApplied(false);
      setFilterType("");
      setSearchQuery("");
    }
  };

  // ------- Get Collection Inventory Id -------
  const getCollectionListFunction = async (tenantId) => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/transaction?tenantId=${tenantId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const getCollectionListSuccess = (res) => {
    if (res?.isSuccess) {
      setCollectionList(res || []);
      setCollectionDetail(true);
    }
  };

  const getCollectionListError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching deals");
  };

  const { mutate: getCollectionListMutate, isLoading: collectionLoading } =
    useMutation(getCollectionListFunction, {
      onSuccess: getCollectionListSuccess,
      onError: getCollectionListError,
    });


  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Revenue
          <Underline />
        </BoxTitle>
      </BoxHead>

      <SideModal isOpen={isViewCommissionModalOpen} onClose={() => setIsViewCommissionModalOpen(false)}>
        <ViewCommissionModal
          key={selectedData?.dealId}
          commissionData={commissionData}
          handleClose={() => setIsViewCommissionModalOpen(false)}
          selectedData={selectedData}
          setIsDealClouser={setIsTrackCommissionModalOpen}
        />
      </SideModal>

      <SideModal
        isOpen={isTrackCommissionModalOpen}
        onClose={() => setIsTrackCommissionModalOpen(false)}
        width={"1/3"}
        level="high"
      >
        <TrackCommission
          handleClose={() => setIsTrackCommissionModalOpen(false)}
          selectedData={selectedData}
          trackCommissionMutate={trackCommissionMutate}
          trackCommissionLoading={trackCommissionLoading}
        />
      </SideModal>

      <SideModal
        isOpen={collectionDetail}
        onClose={() => setCollectionDetail(false)}
      >
        <ViewCollectionModal
          handleClose={() => setCollectionDetail(false)}
          selectedData={selectedData}
          setCollectionDetail={setCollectionDetail}
          apiData={activeLeaseData}
          loading={isLoading}
          collectionList={collectionList}
        />
      </SideModal>

      <FloorTabs>
        <FloorTab
          onClick={() => handleTabChange('1')}
          $active={activeTab === "1"}
        >
          One-Time (Commission)
        </FloorTab>
        <FloorTab
          onClick={() => handleTabChange('2')}
          $active={activeTab === "2"}
        >
          Recurring (Active Leases)
        </FloorTab>
      </FloorTabs>

      {/* {!isFocused && <SummarySkeletonLoading count={4} />}

      {isFocused && summaryData && (
        <CommissionSummaryCards summaryData={summaryData} />
      )} */}

      {!isLoading && (
        <TableWrapper>
          <Table
            apiData={activeTab === "1" ? apiData : activeLeaseData}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            activeTab={activeTab}
            getCommissionPaidMutate={getCommissionPaidMutate}
            setCollectionDetail={setCollectionDetail}
            getCollectionListMutate={getCollectionListMutate}
          />
          {/* {(!apiData || apiData.length === 0) && <NotFoundModel />} */}
          {(
            activeTab === "1"
              ? !apiData || apiData.length === 0
              : !activeLeaseData || activeLeaseData.length === 0
          ) && <NotFoundModel />}
        </TableWrapper>
      )}
      {/* </FilterTableWrapper> */}
      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3 cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
export default Revenue;